import * as types from "./types";

export const setMessage = data => ({
  type: types.SET_CHAT_MESSAGE,
  payload: data
});
